import * as React from 'react'; 
import { Link } from 'react-router-dom';

export const Tile = (props) => (
    <Link to={props.route} style={{ textDecoration: 'none', color: 'black'}}>
        <div className={props.animation} style={{ border: 'solid 5px', padding: 5, textAlign: 'center', margin: '0px 20px 20px 20px'}}>
            <div style={typeof props.children === 'string'? styles.text: styles.img}>
                <div style={{ fontSize: 30 }}>
                    <hr style={{ height: 5, backgroundColor: "black" }} />
                    {props.children}
                </div>
            </div>
        </div>
    </Link>
)

const styles = {
    img: {
        border: 'solid',
        padding: '5px'
    },
    text: {
        border: 'solid',
        padding: '50px 60px 80px 60px'
        
    }
}


// WEBPACK FOOTER //
// ./src/components/marketing/components/Tile.js